







































































































































































import Vue from "vue";
import moment from "moment";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import InstallationResumeDialog from "@/components/InstallationResumeDialog.vue";
import NewSoftwareVersionsFilter from "@/components/TableHeaderFilters/NewSoftwareVersionsFilter.vue";

// Model
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { dataTableItemsPerPage } from "@/utility/Constants";
import { ConfigurationComparisonEnum } from "@/model/data/enums/ConfigurationComparisonEnum";

import VFaIcon from "@/components/VFaIcon.vue";
import { InstallationSecurityConfiguration } from "@/model/data/security/InstallationSecurityConfiguration";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { mapGetters } from "vuex";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";

export default Vue.extend({
    components: {
        TableFiltersRow,
        VFaIcon,
        ColumnVisibilityFilter,
        DeviceModelChip,
        BranchFilter,
        DateRangeFilter,
        InstallationResumeDialog,
    },
    data() {
        return {
            moment,
            ConfigurationComparisonEnum,
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            firstTime: true,
            LicenseModuleEnum,
            dataTableItemsPerPage,
            ignoreOptionsChanges: false,
            ignoreDataChanges: false,
            confirmationDialog: false,
            options: {},
            selectedItems: [],
            availableHeaders: [],
            showDialog: false,
            selectedInstallation: null,
            filters: [
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                    customAttrs: LicenseModuleEnum.SecurityManagement,
                },
                {
                    headerValue: "agent",
                    filterKey: UpdateTypeEnum.Agent,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.Agent },
                },
            ],
        };
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
        reqData: Object,
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
        installations: {
            handler(newValue) {
                if (this.firstTime && this.$route.query.options != null && this.$route.query.options != undefined) {
                    let queryOptions = JSON.parse(atob(this.$route.query.options));
                    this.$emit("options-changed", queryOptions);
                    this.options = queryOptions;
                }
                if (
                    this.firstTime &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != undefined &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != null
                ) {
                    if (this.$route.query.showdialog) this.showDialog = this.$route.query.showdialog == "true";
                    if (this.$route.query.installation) this.selectedInstallation = this.installations.find((i) => i.name == this.$route.query.installation);

                    this.firstTime = false;
                }
            },
            deep: true,
        },
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),

        delaysEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadDelays);
        },
        alarmsEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadAlarms);
        },
        timebandsEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadBands);
        },
        initialAvailableHeaders() {
            let initialAvailableHeaders: any = [
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("security_management.configurationStatus"),
                    value: "comparisonStatus",
                    sortable: false,
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("logAnalysis.scheduleStatus"),
                    value: "scheduled",
                    sortable: false,
                },
                {
                    enabled: true,
                    canBeHidden: false,
                    text: this.$t("common.installationName"),
                    value: "name",
                },
                {
                    enabled: false,
                    canBeHidden: true,
                    text: this.$t("common.tags"),
                    value: "tags",
                    sortable: false,
                },
                {
                    enabled: false,
                    canBeHidden: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                },
                {
                    enabled: true,
                    text: this.$t("common.agent_version"),
                    value: "agent",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("common.agent_ip"),
                    value: "agentInfo.ip",
                },
                {
                    enabled: false,
                    text: this.$t("device_status.pc_name"),
                    value: "connectedPc",
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("common.last_update"),
                    value: "lastMessage",
                },
                {
                    enabled: false,
                    text: this.$t("common.last_agent_message"),
                    value: "agentInfo.lastMessage",
                    sortable: true,
                },
                {
                    enabled: true,
                    text: this.$t("common.device/s"),
                    value: "machines",
                    sortable: false,
                },
            ];
            if (this.delaysEnabled || this.alarmsEnabled || this.timebandsEnabled)
                initialAvailableHeaders.push({
                    enabled: true,
                    text: this.$t("common.actions"),
                    value: "actions",
                    sortable: false,
                    width: "150px",
                });
            return initialAvailableHeaders;
        },
    },
    methods: {
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = false;
                this.options.page = 1;
                console.log("backToTheFirst, this.options: ", this.options);
            }
        },
        handleClick(value: InstallationSecurityConfiguration) {
            if (window.getSelection().toString()) {
                return;
            }
            this.showDialog = true;
            this.selectedInstallation = value;
        },
        newTabDialog(value: any) {
            if (this.reqData) {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)), reqData: btoa(JSON.stringify(this.reqData)) },
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)) },
                });
                window.open(routeData.href, "_blank");
            }
        },
    },
});
